import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import PropTypes from "prop-types"
import { forwardRef } from "react"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const FloatSelect = forwardRef(
  (
    {
      className,
      containerClassName,
      error,
      id,
      label,
      labelClassName,
      value,
      ...props
    },
    ref
  ) => {
    const float = !!value && !!label

    return (
      <div className={cn("relative", containerClassName)}>
        {label && (
          <label
            className={cn(
              "text-12 pointer-events-none absolute left-0 inline-block px-12 leading-10 text-black transition-all duration-200",
              float ? "top-6 opacity-100" : "top-12 opacity-0",
              labelClassName
            )}
            htmlFor={id}
          >
            {label}
          </label>
        )}
        <select
          aria-invalid={!!error}
          className={cn(
            "leading-24 text-16 focus:ring-3 focus:ring-selected placeholder:text-grey-50 border-grey-30 h-44 w-full max-w-full flex-1 appearance-none rounded-md border bg-white px-12 text-black outline-none transition-all duration-200 focus:border-black",
            float && "pt-14",
            error && "focus:border-error focus:border-2",
            className
          )}
          id={id}
          ref={ref}
          value={value}
          {...props}
        />
        <FontAwesomeIcon
          className="text-12 text-grey-65 pointer-events-none absolute right-12 top-16"
          icon={faChevronDown}
        />
        {error && (
          <p className="text-error text-14 leading-20 mt-6">
            {error.message || error}
          </p>
        )}
      </div>
    )
  }
)

FloatSelect.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  id: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

FloatSelect.displayName = "FloatSelect"

export default FloatSelect
